import { useLocation } from '@fs/zion-router'
import { useEffect, useState } from 'react'
import { usabillaConfig } from '../../../config'

const getFeedbackUrl = (path: string): string => {
  const found = usabillaConfig.options.find((option: { form: string; whiteList?: RegExp[] }) => {
    if (option.whiteList) {
      return option.whiteList.some((url: RegExp) => {
        return new RegExp(url).test(path)
      })
    }
    // use the default form
    return true
  })
  return found ? found.form : ''
}

export const useFeedback = (): { feedbackUrl: string } => {
  const location = useLocation()
  const [feedbackUrl, setFeedbackUrl] = useState('')

  useEffect(() => {
    setFeedbackUrl(getFeedbackUrl(location.pathname))
  }, [location.pathname])

  return { feedbackUrl }
}
